import { Link } from 'react-router-dom';
import type { EntryRecord } from '../../db/schema';
import type { Category, ProjectsDoc } from '../../domain/types';
import { formatTime } from '../../lib/datetime';
import { EntryBadge } from './EntryBadge';
import { MediaImage } from './MediaImage';

export function EntryCard({
  entry,
  categories,
  projects,
  compact = false,
}: {
  entry: EntryRecord;
  categories: Map<string, Category>;
  projects?: ProjectsDoc;
  compact?: boolean;
}) {
  const photos = entry.media.slice(0, 4);
  const extra = entry.media.length - photos.length;

  return (
    <Link to={`/entry/${entry.id}`} className={`card${compact ? ' card-compact' : ''}`}>
      <div className="card-head">
        <span className="card-time">{formatTime(entry.date)}</span>
        <EntryBadge
          categoryId={entry.categoryId}
          projectId={entry.projectId}
          categories={categories}
          projects={projects}
        />
        {entry._dirty && (
          <span className="card-dirty" title="未同期">
            ↑
          </span>
        )}
      </div>
      <div className="card-title">{entry.title || '（無題）'}</div>
      {!compact && entry.body && <div className="card-body">{entry.body}</div>}
      {entry.media.length > 0 && (
        <div className="card-thumbs">
          {photos.map((m) => (
            <MediaImage key={m.id} media={m} month={entry.monthKey} entryId={entry.id} className="thumb" />
          ))}
          {extra > 0 && <div className="thumb thumb-more">+{extra}</div>}
        </div>
      )}
      {entry.location && (
        <div className="card-meta">
          📍 {entry.location.lat.toFixed(4)}, {entry.location.lng.toFixed(4)}
        </div>
      )}
    </Link>
  );
}
